<template>
  <m-dialog ref="unggahNilaiDlg" :isclose="true" @save="save" :fullscreen="true" title="Unggah Nilai">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="12" md="10" lg="8" xl="8">
        <v-form @submit.prevent data-vv-scope="form" lazy-validation>
          <v-file-input v-model="file" label="File input"></v-file-input>
        </v-form>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
export default {

  data() {
    return {
      file: null,
      kelas: null,
    };
  },
  methods: {
    open(o) {
      this.kelas = {...o}
      let x = this.$refs.unggahNilaiDlg.open();
      this.$validator.reset();
      return x;
    },

    // eslint-disable-next-line
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          this.$confirm(`Apakah Anda yakin akan mengunggah Nilai LMS pada Kelas ini ?`)
            .then(() => {
              return this.$store
                .dispatch("kelas/inputNilaiXLS", {
                  instansi_id: this.instansi_id,
                  kelas_id: this.kelas.id,
                  obj: this.file
                })
                .then(res => {
                  if (res.error) {
                    this.$error("Simpan penilaian Kelas gagal");
                  } else {
                    this.$info("Simpan penilaian kelas berhasil");
                    this.$refs.unggahNilaiDlg.resolve();
                  }
                });
            })
            .catch(e => e);
        });
    },
  },
};
</script>
